function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/** Prototype-style Manual Sort control — switch toggle, not a checkbox input. */
export default function ManualSortToggle({ enabled = false, onToggle, className = "" }) {
  return (
    <div
      className={classNames(
        "relative -mt-1.5 inline-block border-l border-gray-200 px-4 text-left",
        className
      )}
    >
      <div className="group inline-flex items-center justify-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900">
        <button
          type="button"
          className="cursor-pointer whitespace-nowrap bg-transparent p-0 text-inherit"
          onClick={onToggle}
        >
          Manual Sort
        </button>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          aria-label="Manual Sort"
          onClick={onToggle}
          className="relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-offset-2"
        >
          <span
            className={classNames(
              "absolute mx-auto h-4 w-9 rounded-full ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out",
              enabled ? "bg-indigo-600" : "bg-gray-200"
            )}
          />
          <span
            className={classNames(
              "absolute left-0 size-5 rounded-full border border-gray-300 bg-white shadow-sm transition-transform duration-200 ease-in-out",
              enabled ? "translate-x-5" : "translate-x-0"
            )}
          />
        </button>
      </div>
    </div>
  );
}
